module.exports = __webpack_public_path__ + "img/img_honor8_us@3x.a5e54018.png";